module.exports = __webpack_public_path__ + "img/20190723144754341.2fb1938c.png";